import {
  PreOrderOutput,
  PreOrderQueryParams,
  PreOrderStatus,
} from "@/interfaces/pre-orders";
import { BaseService, QueryParams } from "./BaseService";
import { OrderOutput } from "@/interfaces/orders";

export class PreOrderService extends BaseService<
  unknown,
  PreOrderOutput,
  PreOrderQueryParams
> {
  constructor() {
    super();
    this.path = "pre_orders";
  }

  async updateStatus(
    id: string,
    status: PreOrderStatus,
    params?: QueryParams
  ): Promise<PreOrderOutput> {
    return this.request(`${this.path}/${id}`, {
      queryParams: params,
      method: "PUT",
      body: JSON.stringify({ status }),
    });
  }

  async acceptPreOrder(
    id: string,
    params?: QueryParams
  ): Promise<{ message: string; data: OrderOutput | null }> {
    return this.request(`${this.path}/${id}/accept`, {
      queryParams: params,
      method: "POST",
    });
  }

  async rejectPreOrder(
    id: string,
    params?: QueryParams
  ): Promise<{ message: string; data: PreOrderOutput | null }> {
    return this.request(`${this.path}/${id}/reject`, {
      queryParams: params,
      method: "POST",
    });
  }
}
